module.exports = __webpack_public_path__ + "static/grapes-3a13c02196892655b465d5fc867b76e0.svg";